export const NAV_ITEM_BUTTON_STYLES =
  "w-full h-9 min-h-9 px-2 py-2 rounded-md justify-start gap-4 has-[>svg]:px-2 flex-0";
